import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useClinic } from "../../context/ClinicContext";
import "../../styles/PublishPage.css";

export default function PublishPage() {
  const navigate = useNavigate();
  const { clinicId, setClinicId } = useClinic();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  // ✅ Set clinicId from token if passed
  useEffect(() => {
    if (token) {
      setClinicId(token);
    } else if (!clinicId) {
      navigate("/admin/create-clinic");
    }
  }, [token, clinicId, setClinicId, navigate]);

  const floatingWidgetCode = `
<script src="https://olumisai.com/widget.js"
        data-clinic-id="${clinicId}"
        data-icon-url="https://olumisai.com/logo.svg"
        data-theme-color="#004aad">
</script>`;

  const embedWidgetCode = `
<script src="https://olumisai.com/widget.js" data-clinic="${clinicId}"></script>`;

  const standaloneLink = `https://olumisai.com/chat/${clinicId}`;

  const handleCopy = (text) => {
    navigator.clipboard.writeText(text);
  };

  return (
    <div className="container">
      {/* === Header === */}
      <div className="header-row">
        <div className="header-left">
          <img src="/logo.png" alt="Olumis AI Logo" className="logo" />
          <button className="all-clinics-btn" onClick={() => navigate("/admin/all-clinics")}>
            All Clinics
          </button>
        </div>
      </div>

      {/* === Stepper === */}
      <div className="stepper">
        <button className="step active">Create New Clinic</button>
        <div className="step-divider" />
        <button className="step active">Customize Chatbot</button>
        <div className="step-divider" />
        <button className="step active">AI Training</button>
        <div className="step-divider" />
        <button className="step current">Publish</button>
      </div>

      {/* === Publish Options === */}
      <div className="publish-content">
        <h2>Option 1: Floating Chat Widget</h2>
        <div className="code-box">
          <pre>{floatingWidgetCode}</pre>
          <button onClick={() => handleCopy(floatingWidgetCode)}>📋 Copy</button>
        </div>

        <h2>Option 2: Website Embed Widget</h2>
        <div className="code-box">
          <pre>{embedWidgetCode}</pre>
          <button onClick={() => handleCopy(embedWidgetCode)}>📋 Copy</button>
        </div>

        <h2>Option 3: Standalone Chat Link</h2>
        <div className="code-box">
          <pre>{standaloneLink}</pre>
          <button onClick={() => handleCopy(standaloneLink)}>📋 Copy</button>
        </div>

        <h2>Option 4: QR Code</h2>
        <div className="qr-code">
          <img
            src={`https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${encodeURIComponent(
              standaloneLink
            )}`}
            alt="QR Code"
          />
        </div>
      </div>
    </div>
  );
}
